var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"businessGroupWh"},[_c('slider',{on:{"load-table":_vm.handleLoadTable}}),_c('tableList',{attrs:{"id":_vm.selectId,"table-data":_vm.tableData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }